<div mat-dialog-content>
    <p>{{data.question}}</p>
    
  </div>
  <div mat-dialog-actions align="end" >
    
    <button mat-button [mat-dialog-close]="'ok'" cdkFocusInitial >Confirmar</button>
  &nbsp;
   <button mat-button (click)="onNoClick()">Cancelar</button>
  </div>
  